export const DEFAULT_DOCUMENT_TITLE = '클로브 - 빠르고 간편한 기업금융';
export const DEFAULT_PARTNER_DOCUMENT_TITLE = '자료 전송 간편화 서비스';
